<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :class="caption ? 'p-4 bg-gray-100' : null"
  >
    <figure
      :class="caption ? 'mb-4' : null"
    >
      <FocalImage
        v-if="imageData"
        :image="imageData"
        :img-class="imageClasses"
      />
      <figcaption
        v-if="caption"
        class="text-sm"
        v-html="caption"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ImageWithFocalPoint } from '@/ts/types/focal-point';

interface Props {
  title?: string;
  aspect?: 'square' | 'landscape' | 'portrait' | 'default';
  round?: boolean;
  width?: string;
  height?: string;
  caption?: string;
  file: string | ImageWithFocalPoint;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  aspect: 'default',
  round: false,
  width: '1280',
  height: '720',
  caption: '',
});

/** Convert file prop to ImageWithFocalPoint format */
const imageData = computed(() => {
  if (typeof props.file === 'string') {
    // Legacy format: just a URL string
    return {
      url: props.file,
      width: parseInt(props.width),
      height: parseInt(props.height),
      focal_point: null,
      title: props.title,
    };
  }
  // New format: ImageWithFocalPoint object
  return props.file;
});

/** Compute CSS classes for the image */
const imageClasses = computed(() => {
  const classes: string[] = [];

  if (props.round) {
    classes.push('rounded-full');
  }

  if (props.aspect === 'square') {
    classes.push('aspect-square');
  }

  return classes.join(' ');
});
</script>
